module.exports = __webpack_public_path__ + "static/media/malatinta.4bb1e332.png";